import { render, staticRenderFns } from "./single.vue?vue&type=template&id=6a3076c4&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=6a3076c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3076c4",
  null
  
)

export default component.exports